import axiosInst from "api/config/axiosConfig";
import { inventoryResponseData, inventoryStatistics } from "./inventory.depot";
import { COLUMN_TYPE } from "utils/constants";
import { DeviceColumnTypes } from "pages/Devices/devices.config";

export interface InventoryStatusTypes {
  serialNumber: string;
  uploadStatus: string;
}

export interface InventoryValueTypes {
  deviceType?: string;
  serialNumber: string;
  imei: string;
  mac: string;
}

export const INVETNORY_COLUMNS: DeviceColumnTypes[] = [
  {
    id: "serialNumber",
    label: "Serial Number",
    filter: true,
    isSort: true,
    type: COLUMN_TYPE.STRING,
  },
  {
    id: "mac",
    label: "MAC",
    filter: true,
    isSort: true,
    type: COLUMN_TYPE.STRING,
  },
  {
    id: "imei",
    label: "IMEI",
    filter: true,
    isSort: true,
    type: COLUMN_TYPE.STRING,
  },
];

export const DEVICE_SPEEDWAY: string = "Speedway";

export async function postInventoryData(data: InventoryValueTypes) {
  const response = await axiosInst.post("/beta/inventoryUIHook", data);
  const inventoryArray = [...inventoryResponseData.data, response.data];
  inventoryStatistics.setData({ resultsQty: inventoryArray.length });
  inventoryResponseData.setData(inventoryArray);
}

export const getInventoryDevice = async (data: any) => {
  const dataKey = Object.keys(data);
  const param = dataKey[0];
  const value = data[param];
  const response = await axiosInst.get(`/beta/inventoryUIHook?${param}=${value}`);
  return response.data;
};
